module.exports = __webpack_public_path__ + "static/about-66d167467a4f99c328925ef610b19e6a.jpg";